import React, { useState } from "react";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";
import api from "../api";
import { usePageTitle } from "../components/common";

export default function Retractation() {
  usePageTitle("Exercer mon droit de rétractation");
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", order_number: "", service_name: "", website: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/retractation", form);
      setDone(true);
      toast.success("Ta demande de rétractation a bien été enregistrée ✨");
    } catch {
      toast.error("Une erreur est survenue.");
    } finally { setSending(false); }
  };

  if (done)
    return (
      <div className="container-x py-20 text-center fade-up max-w-lg">
        <Undo2 className="mx-auto text-[#C9A56A]" size={30} />
        <h1 className="mt-4 font-serif text-2xl text-[#5A3A4B]">Demande enregistrée</h1>
        <p className="mt-3 text-sm text-[#7A5D58]">Un accusé de réception vient de t'être envoyé par e-mail. Ta demande sera traitée dans les meilleurs délais.</p>
      </div>
    );

  return (
    <div className="container-x py-12 sm:py-20 fade-up max-w-lg">
      <h1 className="font-serif text-3xl sm:text-4xl font-medium text-[#5A3A4B]">Exercer mon droit de rétractation</h1>
      <p className="mt-3 text-sm text-[#7A5D58] leading-relaxed">
        Tu disposes d'un délai de 14 jours pour te rétracter, sauf si tu as demandé l'exécution anticipée et
        que la prestation a été entièrement exécutée. Remplis ce formulaire pour envoyer ta demande.
      </p>
      <div className="gold-divider my-6 w-28" />
      <form onSubmit={submit} className="card-soft p-6 space-y-4" data-testid="retractation-form">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="field-label">Prénom</label><input required className="field-input" value={form.first_name} onChange={set("first_name")} data-testid="retract-first" /></div>
          <div><label className="field-label">Nom</label><input required className="field-input" value={form.last_name} onChange={set("last_name")} data-testid="retract-last" /></div>
        </div>
        <div><label className="field-label">Email de commande</label><input required type="email" className="field-input" value={form.email} onChange={set("email")} data-testid="retract-email" /></div>
        <div><label className="field-label">Numéro de commande</label><input className="field-input" value={form.order_number} onChange={set("order_number")} placeholder="LMSP-…" data-testid="retract-order" /></div>
        <div><label className="field-label">Prestation concernée</label><input className="field-input" value={form.service_name} onChange={set("service_name")} data-testid="retract-service" /></div>
        <input type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
        <button type="submit" disabled={sending} className="btn-primary w-full" data-testid="retract-submit">
          {sending ? "Envoi…" : "Confirmer ma demande de rétractation"}
        </button>
      </form>
    </div>
  );
}
